import { createRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";

import { FirstAdPurchase } from "./first-ad-purchase";
import { FirstAdPlans } from "../features/onboarding/plans";
import { VERIFIED_ONBOARDING_PLANS } from "../features/onboarding/plans-catalog";
import { firstAdCheckoutAttribution } from "./first-ad-attribution";
import { signedInRoute } from "../platform/routes";

export const firstAdCheckoutRoute = createRoute({
  getParentRoute: () => signedInRoute,
  path: "/start/free/checkout-return",
  staticData: { ownFrame: true },
  validateSearch: (search) => z.object({
    teamId: z.uuid(), brandId: z.uuid(), templateId: z.string().max(64).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    checkout: z.enum(["success", "canceled"]),
    session_id: z.string().max(250).regex(/^cs_[A-Za-z0-9_]+$/).optional().catch(undefined),
  }).parse(search),
  component: Return,
});
function Return() {
  const { checkout, session_id, ...destination } = firstAdCheckoutRoute.useSearch();
  const navigate = useNavigate();
  const [plans, setPlans] = useState(false);
  const onPaidContinue = () => { void navigate({ to: "/" }); };
  if (plans) return <FirstAdPlans {...destination} reason="another-ad" onPaidContinue={onPaidContinue}
    plans={VERIFIED_ONBOARDING_PLANS} checkoutEnabled={false} checkoutAttribution={firstAdCheckoutAttribution}
    onContinueToApp={onPaidContinue}
    onClose={() => setPlans(false)} />;
  return <FirstAdPurchase {...destination} result={checkout} sessionId={session_id ?? null} onPaidContinue={onPaidContinue}
    onContinueToApp={onPaidContinue}
    onChoosePlan={() => setPlans(true)} />;
}
